export const name = "RANGE_BUCKET";
export const summary = `Scans through a sorted array and returns the 0-based position of a point's upper bound.`;
export const reference = `
## RANGE_BUCKET

Scans through a sorted array and returns the 0-based position of a point's upper bound.

\`\`\`
RANGE_BUCKET(point, boundaries_array)
\`\`\`

### Description

\`RANGE_BUCKET\` scans through a sorted array and returns the 0-based position of the point's upper bound. This can be useful if you need to group your data to build partitions, histograms, business-defined rules, and more.

\`RANGE_BUCKET\` follows these rules:

- If the point exists in the array, returns the index of the next larger value.

- If the point doesn't exist in the array, but it falls between two values, returns the index of the larger value.

- If the point is smaller than the first value in the array, returns 0.

- If the point is greater than or equal to the last value in the array, returns the length of the array.

- If the array is empty, returns 0.

- If the point is \`NULL\` or \`NaN\`, returns \`NULL\`.

- The data type for the point and array must be compatible.

Execution failure occurs when:

- The array has a \`NaN\` or \`NULL\` value in it.

- The array isn't sorted in ascending order.


### Parameters

- \`point\`: A generic value.
- \`boundaries_array\`: A generic array of values.


### Note: The data type for point and the element type of boundaries_array
must be equivalent. The data type must be comparable.




### Return Value

\`INT64\`


### Examples

In a table called \`students\`, check to see how many records would exist in each \`age_group\` bucket, based on a student's age:

- age\\_group 0 (age \\< 10)
- age\\_group 1 (age \\>= 10, age \\< 20)
- age\\_group 2 (age \\>= 20, age \\< 30)
- age\\_group 3 (age \\>= 30)



\`\`\`
WITH students AS
(
  SELECT 9 AS age UNION ALL
  SELECT 20 AS age UNION ALL
  SELECT 25 AS age UNION ALL
  SELECT 31 AS age UNION ALL
  SELECT 32 AS age UNION ALL
  SELECT 33 AS age
)
SELECT RANGE_BUCKET(age, [10, 20, 30]) AS age_group, COUNT(*) AS count
FROM students
GROUP BY 1

/*--------------+-------*
 | age_group | count |
 +--------------+-------+
 | 0 | 1 |
 | 2 | 2 |
 | 3 | 3 |
 *--------------+-------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
